import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import { useAuth } from '../../contexts/auth/AuthProvider';

const MainLayout = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Show Navbar if on home page OR if not authenticated
  const showNavbar = location.pathname === '/' || !isAuthenticated;

  return (
    <div>
      {showNavbar && <Navbar />}
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;